import * as ROUTES from '@/router/route-names'

export default [
  {
    path: '/:accountId/bor',
    name: ROUTES.BROKER_OF_RECORD,
    component: () => import('../views/bor/BrokerOfRecordList.vue'),
  },
  {
    path: '/:accountId/bor/new',
    name: ROUTES.BROKER_OF_RECORD_CREATE,
    component: () => import('../views/bor/CreateBrokerOfRecord.vue'),
  },
]
